const RadioButton = ({ value1, value2, value3, caption1, caption2, caption3, defaultChecked1, defaultChecked2, onClick, name }) => {


  return (
    <div>
      <ul
        className="bg-gray-200 dark:bg-gray-900 dark:text-gray-100"
        style={{ borderRadius: "5px" }}
        
      >
        {value1 && <li
          className="radio-switch__item"
          style={{ borderRadius: "5px" }}
        >
          <input
          defaultChecked={defaultChecked1}
            className="radio-switch__input ri5-sr-only"
            type="radio"
            name={name}
            id="radio-1"
            value={value1}
            onClick={onClick}
          />
          <label className="radio-switch__label" htmlFor="radio-1">
            {caption1}
          </label>
        </li>}

        {value2 && <li
          className="radio-switch__item dark:text-gray-100"
          style={{ borderRadius: "5px" }}
        >
          <input
            defaultChecked={defaultChecked2}
            className="radio-switch__input ri5-sr-only"
            type="radio"
            name={name}
            id="radio-2"
            value={value2}
            onClick={onClick}
          />
          {/* onChange={()=>{document.getElementById('radio-2').ariaChecked()} */}
          <label className="radio-switch__label" htmlFor="radio-2">
            {caption2}
          </label>
          <div aria-hidden="true" className={`radio-switch__marker`}></div>
        </li>}

        {value3 && <li
          className="radio-switch__item dark:text-gray-100"
          style={{ borderRadius: "5px" }}
        >
          <input
            defaultChecked={defaultChecked2}
            className="radio-switch__input ri5-sr-only"
            type="radio"
            name={name}
            id="radio-2"
            value={value2}
            onClick={onClick}
          />
          {/* onChange={()=>{document.getElementById('radio-2').ariaChecked()} */}
          <label className="radio-switch__label" htmlFor="radio-2">
            {caption2}
          </label>
          <div aria-hidden="true" className={`radio-switch__marker`}></div>
        </li>}

        
        
      </ul>
    </div>
  );
};

export default RadioButton;